// extracted by mini-css-extract-plugin
module.exports = {"root":"AvailabilityAlerts_root__13GAN"};